import { CALCULATE_SYSTEM_IMMEDIATE, SYSTEM_CALCULATION_REQUEST } from 'actions/designer'
import { takeEvery } from 'redux-saga/effects'
import { handleCalculateSystem, handleCalculationRequest } from '../calculation'
import { CalculationQueueMap } from './types'
import { takeLatestBySystemUuid } from './utils'

// Queue to track active calculations by system UUID
const calculationQueue: CalculationQueueMap = {}

export function* watchSystemCalculationRequest() {
  yield takeEvery(SYSTEM_CALCULATION_REQUEST, handleCalculationRequest)
}

export function* watchCalculateSystem() {
  yield takeLatestBySystemUuid(CALCULATE_SYSTEM_IMMEDIATE, handleCalculateSystem, calculationQueue)
}
